import React, { useId } from 'react';

/**
 * SectionCard — glass card wrapper matching the Dashboard design system.
 * Replaces the old `.panel-card .section-card` classes with the ethereal glass style.
 */
export const SectionCard = ({
  title,
  subtitle,
  actions,
  children,
  className = '',
  titleId,
  as = 'section',
  ariaLabelledBy,
}) => {
  const Component      = as;
  const generatedId    = useId();
  const resolvedTitleId = title ? (titleId || `sc-${generatedId}`) : undefined;

  return (
    <Component
      className={['card-base', 'p-6', className].filter(Boolean).join(' ')}
      aria-labelledby={ariaLabelledBy || resolvedTitleId}
    >
      {(title || subtitle || actions) && (
        <div
          className="flex items-start justify-between gap-4 flex-wrap"
          style={{ marginBottom: (children ? '16px' : '0') }}
        >
          <div className="flex-1 min-w-0">
            {title && (
              <h2
                id={resolvedTitleId}
                className="text-[18px] font-semibold text-lb-ink-strong tracking-normal leading-[1.3] m-0"
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-[14px] text-lb-muted mt-1 leading-[1.5] m-0">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>
          )}
        </div>
      )}
      <div>{children}</div>
    </Component>
  );
};
